export default "<app-company-fields></app-company-fields>";